import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.mask()
    this.element.addEventListener('input', () => this.mask())
  }

  mask() {
    const d = this.element.value.replace(/\D/g, '').slice(0, 11)
    let v = d.slice(0, 3)
    if (d.length > 3) v += '.' + d.slice(3, 6)
    if (d.length > 6) v += '.' + d.slice(6, 9)
    if (d.length > 9) v += '-' + d.slice(9, 11)
    this.element.value = v
  }

  // Dígito verificador na saída do campo (sem validar a cada tecla).
  validate() {
    const d = this.element.value.replace(/\D/g, '')
    this.element.setCustomValidity(d.length === 0 || this.valid(d) ? '' : 'CPF inválido')
    this.element.reportValidity()
  }

  valid(cpf) {
    if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false
    const n = cpf.split('').map(Number)
    const check = (len) => {
      const sum = n.slice(0, len).reduce((s, x, i) => s + x * (len + 1 - i), 0)
      const r = (sum * 10) % 11
      return r === 10 ? 0 : r
    }
    return check(9) === n[9] && check(10) === n[10]
  }
}
